import { userContext } from "Context/userContext";
import React, { useContext } from "react";
import { useEffect } from "react";
import { useCallback } from "react";
import { useState } from "react";
// import { getKecamatan } from "services/apiRoutes";

export default function Kecamatan({ onChange, disabled,all }) {
  const dataContext = useContext(userContext);

  const [kec, setKec] = useState([]);

  const kecAPI = useCallback(async (e) => {
    // const res = await getKecamatan(e);
    // const { data } = res.data;
    // setKec(data);
  }, []);


  useEffect(() => {
    kecAPI(dataContext.kab);
  }, [dataContext, kecAPI]);

  return (
    <div className="flex flex-col">
      <label htmlFor="kabupaten" className="m-2 text-sm font-semibold">
        Kecamatan
      </label>
      <select
        // defaultValue={defaultValue}
        // value={setValue}
        disabled={disabled}
        onChange={onChange}
        name="kecamatan"
        className="px-3 py-3 mr-4 border seacrh rounded-2xl focus:ring-2 focus:ring-primary focus:border-none focus:outline-none"
      >
        <option
          key="453edfvr"
          value="null"
          disabled={!all}
        >
          Semua Kecamatan
        </option>
        {kec?.map((e) => (
          <option key={e.kodeKecamatan} value={e.kodeKecamatan}>
            {e.namaKecamatan}
          </option>
        ))}
      </select>
    </div>
  );
}
